import React from 'react';

export const WORKFLOW_FLOATING_PANEL_CLASS =
  'rounded-md border border-border/80 bg-background/95 p-1.5 shadow-md backdrop-blur-sm';

/** Graph toolbar slot floating over the canvas (Runs live in the bottom panel). */
export const WorkflowEditorFloatingChrome: React.FC<{
  onToolbarSlotChange: (node: HTMLDivElement | null) => void;
}> = ({ onToolbarSlotChange }) => {
  return (
    // `right-3` as well as `left-3`: without a right edge this box was as wide
    // as its content, so an expanded toolbar — ten labelled buttons — simply
    // ran off the side of a phone with its last actions unreachable. Bounded to
    // the canvas, the toolbar below can scroll within it instead. The box stays
    // `pointer-events-none`, so spanning the canvas costs no panning or
    // node-dragging; only the slot inside it takes events.
    <div className="pointer-events-none absolute top-3 right-3 left-3 z-20 flex items-center gap-2">
      <div
        ref={onToolbarSlotChange}
        className="pointer-events-auto min-w-0 empty:hidden"
      />
    </div>
  );
};
